import { SeccionesRolesEnum } from '@/core/enum/RolSeccions.enum';
import { LoggerService } from '@/core/service/logger/logger.service';
import { RoleAccessService } from '@/core/service/role-access/role-access.service';
import { UserDataStore } from '@/store/user-store/user-data.store';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom, map, take } from 'rxjs';

export const deviationManagementGuard: CanActivateFn = async () => {
  const userStore = inject(UserDataStore);
  const router = inject(Router);
  const roleService = inject(RoleAccessService);
  const logger = inject(LoggerService);

  return await firstValueFrom(
    toObservable(userStore.isLoaded).pipe(
      filter(loaded => loaded),
      take(1),
      map(() => {
        const hasBusinessAccess = userStore.isRetailFuels() || userStore.isAgroFuels();
        const hasRoleAccess = roleService.isVisibleForRol(SeccionesRolesEnum.GESTION_DESVIOS);
        const canPass = hasBusinessAccess && hasRoleAccess;

        logger.log(
          {
            isRetailFuels: userStore.isRetailFuels(),
            isAgroFuels: userStore.isAgroFuels(),
            hasBusinessAccess,
            hasRoleAccess,
            canPass,
          },
          'deviationManagementGuard',
          '#gestion-desvios',
        );

        return canPass ? true : router.createUrlTree(['/portal/home']);
      }),
    ),
  );
};
